import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Product } from '../swagger';
import { Details } from './dialogs/Details';
import { Markdown } from './Markdown';

interface Props {
  product: Product;
}

export const InsuranceDetails: React.FC<Props> = ({ product }) => {
  const intl = useIntl();
  const extras = [
    product.meta?.ppsa && intl.formatMessage({ id: 'ppsa' }),
    product.meta?.pressure && intl.formatMessage({ id: 'pressure' }),
  ]
    .filter(Boolean)
    .map((s) => `+${s}`)
    .join(' ');

  return (
    <Details
      details={
        <Box p={3}>
          <Markdown children={`product.${product.type}.description`} />
        </Box>
      }
    >
      <Typography variant="h6">
        <FormattedMessage id={`product.${product.type}.title`} />
      </Typography>
      {extras && (
        <>
          &nbsp;
          <Typography
            variant="body1"
            style={{ textTransform: 'none', marginBottom: 0 }}
          >
            {extras}
          </Typography>
        </>
      )}
    </Details>
  );
};
